const adminRoutes = [
  { path: '/adminPanel', to: '/adminPanel', name: 'Admin panel', icon: 'pe-7s-graph' },
];

export default adminRoutes;
